import React, { type FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Favorite } from 'reactApp/ui/DataListItemCommonComponents/Favorite/Favorite';
import { Publish } from 'reactApp/ui/DataListItemCommonComponents/Publish/Publish';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import type { AllDocumentsItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import { useCompactView } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../../DataListItemRow.new.css';
import { ItemDestination } from './components/ItemDestination';
import { Name } from './components/Name';

export const AlldocumentsItem: FC<AllDocumentsItemProps> = (props) => {
    const {
        id,
        home,
        storage,
        isPublic,
        isSeoEnabled,
        size,
        mtime,
        ext,
        deniedByRights,
        favoritesAvailable,
        isSelected,
        isInFavorites,
        showDownloadButton,
        showPublishButton,
        onCheckboxClick,
        onFavorites,
        onDownload,
        onPublish,
    } = props;
    const path = home === '/' ? 'Облако' : home;

    const isCompact = useCompactView();
    const isAccessDenied = Boolean(deniedByRights);

    return (
        <>
            <TableColumn>
                <Checkbox
                    isDisabled={isAccessDenied}
                    viewType={EViewMode.list}
                    className={styles.check}
                    onCheckboxClick={onCheckboxClick}
                    isSelected={isSelected}
                />
            </TableColumn>

            {isCompact ? (
                <TableColumn width="100%" overflow="hidden">
                    <div className={styles.nameWrapper}>
                        <Name {...props} isAccessDenied={isAccessDenied} />
                        <ItemDestination isCompact path={path} isAccessDenied={isAccessDenied} />
                        <span className={styles.responsiveDateWrapper}>
                            <Size size={size} isInline />
                            {!!mtime && <>&nbsp;•&nbsp;</>}
                            <Date date={mtime} className={styles.date} />
                        </span>
                    </div>
                </TableColumn>
            ) : (
                <>
                    <TableColumn width="100%" overflow="hidden">
                        <Name {...props} isAccessDenied={isAccessDenied} />
                    </TableColumn>
                    <TableColumn width="80%" overflow="hidden">
                        <ItemDestination path={path} isAccessDenied={isAccessDenied} />
                    </TableColumn>
                    <TableColumn flexBasis={100} flexShrink={0} justifyContent="flex-end">
                        <Date date={mtime} />
                    </TableColumn>
                    <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                        <Size size={size} />
                    </TableColumn>
                </>
            )}

            <TableColumn flexBasis={100} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Favorite
                    className={styles.favoriteAction}
                    isAvailable={favoritesAvailable}
                    isFavorite={isInFavorites}
                    onClick={onFavorites}
                    viewType={EViewMode.list}
                />
                {showPublishButton && (
                    <Publish viewType={EViewMode.list} onClick={onPublish} isShared={isPublic} isSeoEnabled={isSeoEnabled} />
                )}
                {showDownloadButton && (
                    <Download onClick={onDownload} ext={ext} size={size} id={id} storage={storage} viewType={EViewMode.list} />
                )}
            </TableColumn>
        </>
    );
};
